export const MULTISELECT_FILTER = 'MULTISELECT' as const;
export type MULTISELECT_FILTER_TYPE = typeof MULTISELECT_FILTER;

export const RANGE_FILTER = 'RANGE' as const;
export type RANGE_FILTER_TYPE = typeof RANGE_FILTER;

export const BUCKET_FILTER = 'BUCKET' as const;
export type BUCKET_FILTER_TYPE = typeof BUCKET_FILTER;

export const LINK_FILTER = 'LINK' as const;
export type LINK_FILTER_TYPE = typeof LINK_FILTER;

export const SET_FILTERS = 'SET_FILTERS' as const;
export type SET_FILTERS_TYPE = typeof SET_FILTERS;

export const REMOVE_FILTER = 'REMOVE_FILTER' as const;
export type REMOVE_FILTER_TYPE = typeof REMOVE_FILTER;

export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS' as const;
export type SET_ACTIVE_FILTERS = typeof SET_ACTIVE_FILTERS;

export enum FilterContentTypes {
  SIZE = 'SIZE',
}

export enum BrandListerGroupedFilterTypes {
  ALL = 'all',
  POPULAR = 'popular',
  NUMBERS = '0-9',
}
